module.exports = __webpack_public_path__ + "img/RedteaSIM 首图@2x.4787b053.png";